import { Box, Link, Modal, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { HiddenMessageProps } from 'types';
import { ModalBoxStyleLarge } from '../ModalBox/styles';

const HiddenMessageTypo = (hiddenMessage: HiddenMessageProps) => {
	const [isOverflow, setIsOverflow] = useState(false);
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<>
			<Stack pb={2} direction="row" spacing={1}>
				<Typography
					textOverflow="ellipsis"
					overflow="hidden"
					whiteSpace="nowrap"
					ref={(el) => {
						el && setIsOverflow(el.scrollWidth > el.offsetWidth);
					}}
				>
					{hiddenMessage.message}
				</Typography>
				{isOverflow ? (
					<>
						<Typography
							textAlign="right"
							whiteSpace="nowrap"
							onClick={() => {
								handleOpen();
							}}
						>
							See More
						</Typography>
						<Modal open={open} onClose={handleClose}>
							<Stack spacing={1} sx={ModalBoxStyleLarge}>
								<Box width="100%" height="104px">
									{hiddenMessage.image ? (
										<Link
											href={hiddenMessage.imageLink}
											target={'_blank'}
										>
											<Box
												component="img"
												sx={{
													width: '100%',
													maxHeight: '104px',
													objectFit: 'cover',
												}}
												alt="image"
												src={`${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${hiddenMessage['image']}`}
											/>
										</Link>
									) : null}
								</Box>
								<Typography
									sx={{
										overflow: 'scroll',
										overflowWrap: 'break-word',
										maxWidth: '100%',
										maxHeight: '4rem',
									}}
								>
									{hiddenMessage.message}
								</Typography>
							</Stack>
						</Modal>
					</>
				) : null}
			</Stack>
		</>
	);
};

export default HiddenMessageTypo;
